import { IntlShape } from "react-intl";
import { DateFormat, getDateText, getDestinationTimeZone } from "../../../helpers/dateHelper";
import { BookingStatus, getBookingStatusMessageDescriptor } from "../../../models/booking";
import { IVoyageExportStat } from "../../../models/stats";

export const voyageCsvCustomHeaders = [
    "Voyage Name",
    "Ship",
    "ENI-Number",
    "Invoice Address",
    "Contact Details",
    "Charter Company",
    "Voyage Start Date",
    "Voyage End Date",
    "Destination Stop",
    "Area Preference",
    "Arrival Date",
    "Arrival Time",
    "Departure Date",
    "Departure Time",
    "Booking Status",
    "Dock 1",
    "Dock 1 Arrival Date",
    "Dock 1 Arrival Time",
    "Dock 1 Departure Date",
    "Dock 1 Departure Time",
    "Dock 2",
    "Dock 2 Arrival Date",
    "Dock 2 Arrival Time",
    "Dock 2 Departure Date",
    "Dock 2 Departure Time",
    "Dock 3",
    "Dock 3 Arrival Date",
    "Dock 3 Arrival Time",
    "Dock 3 Departure Date",
    "Dock 3 Departure Time",
];

const sanitizeValues = (values: any[]): string[] => {
    return values.map(value => {
        if (value === null || value === undefined) return "";
        const str = String(value);
        return str.replace(/"/g, '""').replace(/\r?\n/g, "\r\n");
    });
};

export const getVoyagesCsvFields = (stats: IVoyageExportStat[], intl: IntlShape): string[][] => {
    const rows: string[][] = [];

    const sortedStats = [...stats].sort((a, b) => {
        const dateA = a.voyageStart ?? 0;
        const dateB = b.voyageStart ?? 0;
        if (dateA !== dateB) {
            return dateA - dateB;
        }
        return (a.voyageName ?? "").localeCompare(b.voyageName ?? "");
    });

    sortedStats.forEach(stat => {
        const timeZone = getDestinationTimeZone(stat.destinationZone);
        const bookingStatus = stat.status
            ? intl.formatMessage(
                  getBookingStatusMessageDescriptor({
                      status: stat.status as BookingStatus,
                      count: 0,
                  }),
              )
            : "";

        const row = [
            stat.voyageName ?? "",
            stat.shipName ?? "",
            stat.shipEni ?? "",
            stat.invoiceAddress ?? "",
            stat.contactDetails ?? "",
            stat.charterCompany ?? "",
            stat.voyageStart
                ? getDateText(
                      stat.voyageStart,
                      DateFormat.CLIENT_DATE,
                      getDestinationTimeZone(stat.voyageStartZone),
                  )
                : "",
            stat.voyageEnd
                ? getDateText(
                      stat.voyageEnd,
                      DateFormat.CLIENT_DATE,
                      getDestinationTimeZone(stat.voyageEndZone),
                  )
                : "",
            stat.destinationName ?? "",
            stat.areaPreference ?? "",
            stat.arrivalTime ? getDateText(stat.arrivalTime, DateFormat.CLIENT_DATE, timeZone) : "",
            stat.arrivalTime ? getDateText(stat.arrivalTime, DateFormat.CLIENT_TIME, timeZone) : "",
            stat.departureTime
                ? getDateText(stat.departureTime, DateFormat.CLIENT_DATE, timeZone)
                : "",
            stat.departureTime
                ? getDateText(stat.departureTime, DateFormat.CLIENT_TIME, timeZone)
                : "",
            bookingStatus,
        ];

        // Process Docks up to 3
        const maxStops = 3;
        for (let i = 0; i < maxStops; i++) {
            if (stat.berthings && stat.berthings[i]) {
                const s = stat.berthings[i];
                row.push(s.dockName ?? "");
                row.push(s.arrival ? getDateText(s.arrival, DateFormat.CLIENT_DATE, timeZone) : "");
                row.push(s.arrival ? getDateText(s.arrival, DateFormat.CLIENT_TIME, timeZone) : "");
                row.push(
                    s.departure ? getDateText(s.departure, DateFormat.CLIENT_DATE, timeZone) : "",
                );
                row.push(
                    s.departure ? getDateText(s.departure, DateFormat.CLIENT_TIME, timeZone) : "",
                );
            } else {
                // blank columns for missing stops
                row.push("", "", "", "", "");
            }
        }

        rows.push(sanitizeValues(row));
    });

    return rows;
};
